import React, { Component } from "react";
import deepcopy from "rfdc";
import InlineContactDisplay from "./components/InlineContactDisplay";
import InlineContactForm from "./forms/InlineContactForm";
import { validateContact } from "./utils/utils";

const PAGE_MODES = {
    VIEW_CONTACT: "VIEW_CONTACT",
    EDIT_CONTACT: "EDIT_CONTACT",
}

const FORM_DATA_NAMES_BY_MODE = {
    EDIT_CONTACT: "contactFormData",
}


class InlineContactContainer extends Component {

    // Initialize

    constructor(props) {
        super(props)

        let defaultMode = this.props.formMode || PAGE_MODES.VIEW_CONTACT

        const contact = deepcopy()(this.props.contact)
        const isNewAddition = contact.__new__ === true

        if (isNewAddition) {
            defaultMode = PAGE_MODES.EDIT_CONTACT
            delete contact.__new__
        }

        this.state = {
            removed: false,
            isNewAddition: isNewAddition,
            contactData: contact,
            contactFormData: deepcopy()(contact),
            mode: defaultMode,
        }
    }

    // Form helpers

    updateFormData = (formName, fieldName, fieldValue) => {
        this.setState((state, props) => {
            let updatedState = state
            updatedState[formName][fieldName] = fieldValue
            return updatedState
        })
    }

    switchFormMode = (mode) => {
        this.setState((state, props) => {
            let updatedState = state
            updatedState.mode = mode
            return updatedState
        })
    }

    switchToDisplay = () => {
        this.setState((state, props) => {
            let updatedState = state

            // Reset primary form data
            updatedState[FORM_DATA_NAMES_BY_MODE[state.mode]] = deepcopy()(this.props.contact)
            return updatedState
        })
        this.switchFormMode(PAGE_MODES.VIEW_CONTACT)
    }

    switchToPrimaryForm = () => {
        this.switchFormMode(PAGE_MODES.EDIT_CONTACT)
    }

    softDeleteContact = (json) => {
        this.setState((state, props) => {
            let updatedState = state
            updatedState.removed = true
            return updatedState
        })
    }

    // Handle Actions

    handleActionRequest = (action) => {
        switch (action) {
            case "CONTACT_EDIT":
                this.switchToPrimaryForm()
                break
            case "CONTACT_SAVE":
                const { isValid, errors } = validateContact(this.props.allContacts, this.state.contactFormData, this.props.index)

                if (isValid) {
                    this.setState((state, props) => {
                        let updatedState = state

                        delete state.contactFormData.errors
                        updatedState.contactData = state.contactFormData

                        this.props.updateContact(updatedState.contactData)

                        return updatedState
                    })
                    this.switchFormMode(PAGE_MODES.VIEW_CONTACT)
                }
                else {
                    this.setState((state, props) => {
                        let updatedState = state
                        updatedState.contactFormData.errors = errors
                        return updatedState
                    })
                }
                break
            case "CONTACT_DELETE":
                this.props.deleteContact(this.state.contactData)
                this.softDeleteContact()
                break
            case "CONTACT_CANCEL_EDITS":
                this.switchToDisplay()
                break
            default:
                console.error(`No action handler exists for action "${action}".`)
        }
    }

    // Render

    render = () => {
        if (!this.state.removed) {
            if (this.state.mode === PAGE_MODES.VIEW_CONTACT) {
                return <InlineContactDisplay
                    contact={this.state.contactData}
                    requestAction={this.handleActionRequest}
                />
            }
            else if (this.state.mode === PAGE_MODES.EDIT_CONTACT) {
                return <InlineContactForm
                    contact={this.state.contactFormData}
                    isNewAddition={this.state.isNewAddition}
                    onFormDataChange={(fieldName, fieldValue) => this.updateFormData(FORM_DATA_NAMES_BY_MODE[this.state.mode], fieldName, fieldValue)}
                    requestAction={this.handleActionRequest}
                />
            }
            else {
                return (
                    <div className="data-panel-container data-panel-container--with-margin">
                        <div className="data-panel" aria-label="Unknown Form Mode">
                            <div className="data-panel__form">
                                <p className="data-panel__form__caption">An unhandled form mode was supplied.</p>
                            </div>
                        </div>
                    </div>
                )
            }
        }
        else {
            return null
        }
    }
}

export default InlineContactContainer;
